/**
 * Validates that an ICAN ID is:
 * - Numeric with no decimals.
 * - 5 digits long.
 * @param rule
 * @param value
 * @param callback
 */
export function validateIcanId(rule: any, value: string, callback: any): boolean {
    const icanIdPattern = /^\d{5}$/;
    if (!value && rule.isRequired){
        callback('ICAN ID is required');
        return;
    }

    if (value && !icanIdPattern.test(value)) {
        callback('ICAN ID must be a 5-digit number.');
        return;
    }

    callback();
}